import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { BRAND, CONTACT } from "../data/content";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="bg-black border-t border-white/5 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 relative z-10">
        <div className="border-b border-white/10 pb-12 mb-12">
          <div className="eyebrow">Prêt à passer à l'action ?</div>
          <h2 className="font-display uppercase text-white text-4xl md:text-6xl lg:text-7xl mt-4 leading-[0.95] tracking-tight">
            Prêt à faire<br/>des économies ?
          </h2>
          <div className="flex flex-wrap gap-4 mt-8">
            <Link to="/devis" data-testid="footer-cta-devis" className="btn-primary">
              Obtenir mon étude gratuite <ArrowUpRight className="w-4 h-4" />
            </Link>
            <a href={`tel:${CONTACT.phoneLink}`} data-testid="footer-cta-call" className="btn-secondary">
              <Phone className="w-4 h-4" /> Nous appeler
            </a>
          </div>
        </div>

        <div className="grid md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={BRAND.logo} alt="Optimeo Habitat" className="h-11 w-11 rounded-lg" />
              <div className="font-display uppercase text-white text-lg">Optimeo <span className="text-[#7DD923]">Habitat</span></div>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Rénovation énergétique en Alsace. Pompes à chaleur, climatisation, isolation & accompagnement aux aides.
            </p>
          </div>

          <div>
            <div className="eyebrow mb-4 !text-white/40">Services</div>
            <ul className="space-y-2 text-white/70 text-sm">
              <li><Link to="/services#pompe-a-chaleur" className="hover:text-[#7DD923]">Pompe à chaleur air/eau</Link></li>
              <li><Link to="/services#climatisation" className="hover:text-[#7DD923]">Climatisation réversible</Link></li>
              <li><Link to="/services#isolation" className="hover:text-[#7DD923]">Isolation thermique</Link></li>
              <li><Link to="/services#aides" className="hover:text-[#7DD923]">Accompagnement aides</Link></li>
            </ul>
          </div>

          <div>
            <div className="eyebrow mb-4 !text-white/40">Navigation</div>
            <ul className="space-y-2 text-white/70 text-sm">
              <li><Link to="/simulateur" className="hover:text-[#7DD923]">Simulateur d'aides</Link></li>
              <li><Link to="/realisations" className="hover:text-[#7DD923]">Nos réalisations</Link></li>
              <li><Link to="/blog" className="hover:text-[#7DD923]">Blog conseils</Link></li>
              <li><Link to="/a-propos" className="hover:text-[#7DD923]">À propos</Link></li>
              <li><Link to="/contact" className="hover:text-[#7DD923]">Contact</Link></li>
            </ul>
          </div>

          <div>
            <div className="eyebrow mb-4 !text-white/40">Contact</div>
            <ul className="space-y-3 text-white/70 text-sm">
              <li className="flex items-start gap-2"><Phone className="w-4 h-4 text-[#7DD923] mt-0.5" /><a href={`tel:${CONTACT.phoneLink}`}>{CONTACT.phoneDisplay}</a></li>
              <li className="flex items-start gap-2"><Mail className="w-4 h-4 text-[#7DD923] mt-0.5" /><a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></li>
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-[#7DD923] mt-0.5" /><span>Alsace · Bas-Rhin · Grand Est</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between text-xs text-white/40 gap-2">
          <div>© {new Date().getFullYear()} Optimeo Habitat — Tous droits réservés · SIRET, RGE, QualiPAC, Qualibat</div>
          <div className="flex gap-6">
            <span className="hover:text-white/70 cursor-default">Mentions légales</span>
            <span className="hover:text-white/70 cursor-default">Politique de confidentialité</span>
          </div>
        </div>
      </div>

      <div className="blob" style={{ background: "#7DD923", width: 400, height: 400, bottom: -200, right: -100, opacity: 0.08 }} />
    </footer>
  );
}
